import { render, staticRenderFns } from "./AppointmentsToday.vue?vue&type=template&id=2ef79dbf&scoped=true"
import script from "./AppointmentsToday.vue?vue&type=script&lang=js"
export * from "./AppointmentsToday.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsToday.vue?vue&type=style&index=0&id=2ef79dbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef79dbf",
  null
  
)

export default component.exports